import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "lib/utils";
import type { FC } from "react";
import Loader from "react-loader-spinner";

const loadingVariants = cva("inline-flex items-center justify-center", {
  variants: {
    size: {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-8 h-8",
      lg: "w-16 h-16",
      xl: "w-24 h-24",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const PIXEL_BY_SIZE = {
  xs: 12,
  sm: 16,
  md: 32,
  lg: 60,
  xl: 96,
} as const;

type LoadingVariantProps = VariantProps<typeof loadingVariants>;

export type LoadingProps = {
  size?: NonNullable<LoadingVariantProps["size"]>;
  /** デフォルトはテーマの primary 色 (#0F1649) */
  color?: string;
};

/**
 * 純粋な Loading リーフ。Grid (キューブ) スタイルで全画面統一。
 * size プロパティで一括サイズ管理 (xs/sm/md/lg/xl)。
 * @param {LoadingProps} props Loading の props
 * @return {JSX.Element} Loading 要素
 */
export const Loading: FC<LoadingProps> = ({
  size = "md",
  color = "#0F1649",
}) => {
  const px = PIXEL_BY_SIZE[size];
  return (
    <span
      className={cn(loadingVariants({ size }))}
      role="status"
      aria-label="loading"
    >
      <Loader type="Grid" color={color} width={px} height={px} />
    </span>
  );
};
